import Vue from "vue";

const getDefaultState = () => {
  return {
    PresencesFormationsDeGroupeDeSuperviseur: [],
    PresencesFormationsDeGroupeDuSuperviseur: [],
    //field: "name",
    whereField: "id_responsable",
    //whereValue: "superviseur",
    collection: "presencesFormationsGroupes",
  };
};
const state = getDefaultState();

const mutations = {
  SET_LISTE_DU_SUPERVISEUR(state, payload) {
    state.PresencesFormationsDeGroupeDeSuperviseur = payload;
  },
  SET_PRESENCE_FORMATION_DE_GROUPE_DU_SUPERVISEUR(state, payload) {
    state.PresencesFormationsDeGroupeDuSuperviseur = payload;
  },
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },
  ADD_ONE_ITEM(state, payload) {
    state.PresencesFormationsDeGroupeDeSuperviseur.push(payload);
    state.PresencesFormationsDeGroupeDuSuperviseur.push(payload);
  },
};

const actions = {
  resetState({ commit }) {
    commit("RESET_STATE");
  },

  addOneItem({ commit }, item) {
    commit("ADD_ONE_ITEM", item);
    console.log("added to Vuex PresencesFormationsDeGroupe", item)
  }, 
  GetSuperviseurPresencesFormationsDeGroupe({ commit, dispatch }, objet) {
    // start requête

    commit("SET_LISTE_DU_SUPERVISEUR", []);
   
    commit(
      "Loading/START_BUSY_STATE",
      "PresencesFormationsDeGroupe GetSuperviseurPresencesFormationsDeGroupe",
      {
        root: true,
      }
    );

    let elemsTemp = [];
    if (objet.idAnimateur) {
      this._vm.$firebase
        .firestore()
        .collection("presencesFormationsGroupes")
        .where(
          "formations_groupes_id_formation_groupe",
          "==",
          objet.idFormation.toString()
        )
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach(function (doc) {
            elemsTemp.push({
              ...doc.data(),
              id: doc.id,
            });
          });
          commit("SET_LISTE_DU_SUPERVISEUR", elemsTemp);
          commit(
            "Loading/END_BUSY_STATE",
            "PresencesFormationDesGroupe.store.js",
            {
              root: true,
            }
          );
        })
        .catch((error) => {
          console.log(error);
          let snackbar = {};
          snackbar.showSnackbar = true;
          snackbar.snackbarContent = error.message;
          commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });

          commit(
            "Loading/END_BUSY_STATE",
            "PresencesFormationsDeGroupe.store.js",
            {
              root: true,
            }
          );
        });
    }
  },

  GetPresencesFormationsDeGroupeDuSuperviseur({ commit, dispatch }, objet) {
    console.log("GetPresencesFormationsDeGroupeDuSuperviseur", objet)
    // start requête
    var start = this._vm
    .$moment(Date.now())
    .subtract(3, "months")
    .format("YYYY-MM-DD");
    var end = this._vm
    .$moment(Date.now())
    .add(3, "days")
    .format("YYYY-MM-DD");
    commit("SET_PRESENCE_FORMATION_DE_GROUPE_DU_SUPERVISEUR", []);
    commit("RESET_STATE");
    commit(
      "Loading/START_BUSY_STATE",
      "PresencesFormationsDeGroupe GetPresencesFormationsDeGroupeDuSuperviseur",
      {
        root: true,
      }
    );

    let elemsTemp = [];

    this._vm.$firebase
      .firestore()
      .collection("presencesFormationsGroupes")
      .where("id_responsable", "==", objet.userId)
      .where("programmes_id_programme", "==", objet.project.id)
      .where("date_formation_groupe", ">", start)
      .where("date_formation_groupe", "<", end)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach(function (doc) {
          elemsTemp.push({
            ...doc.data(),
            id: doc.id,
          });
        });
        commit("SET_PRESENCE_FORMATION_DE_GROUPE_DU_SUPERVISEUR", elemsTemp);
        commit(
          "Loading/END_BUSY_STATE",
          "GetPresencesFormationsDeGroupeDuSuperviseur PresencesFormationDesGroupe.store.js",
          {
            root: true,
          }
        );
      })
      .catch((error) => {
        console.log(error);
        let snackbar = {};
        snackbar.showSnackbar = true;
        snackbar.snackbarContent = error.message;
        commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });

        commit(
          "Loading/END_BUSY_STATE",
          "GetPresencesFormationsDeGroupeDuSuperviseur PresencesFormationsDeGroupe.store.js",
          {
            root: true,
          }
        );
      });
  },
};


export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
